import script from "./CallWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallWindow.vue?vue&type=script&setup=true&lang=ts"

import "./CallWindow.vue?vue&type=style&index=0&id=f26f3216&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f26f3216"]])

export default __exports__